export default __webpack_public_path__ + "assets/community-three-two-small.7f7b6eb96aaf47caa1792b9b52874437.png";